<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3">
      <table class="table table-responsive">
        <thead class="thead-light">
          <tr>
            <!-- <th scope="col">B ID</th> -->
            <th scope="col">Agent Number</th>
            <!-- <th scope="col">Call Duration</th> -->
            <th>Type</th>
            <th scope="col">Recording</th>
            <th>Start Time</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in knowlarity_data_by_phone" :key="index">
            <!-- <th scope="row">{{ data.bookingId }}</th> -->
            <td>
              <span class="badge badge-success">{{searchAgent(data.agent_number)}}</span>
            </td>
            <!-- <td>{{ data.call_duration }} seconds</td> -->
            <td>
              <span  v-if="data.Call_Type==0" class="badge badge-primary">Incoming</span>
              <span  v-if="data.Call_Type==1" class="badge badge-secondary">Outgoing</span>
            </td>
            <td>
              <!-- <a v-if="data.call_recording" :href="data.call_recording"
                ><i class="fa fa-microphone" aria-hidden="true"></i
              ></a>
              <a v-else
                ><i class="fa fa-microphone-slash" aria-hidden="true"></i
              ></a> -->
              <audio controls class="p-0" style="margin: 0 auto;">
                    <source :src="data.call_recording" type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>
            </td>
            
            <td style="white-space: nowrap;">
              {{ data.start_time | moment("LLL") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-5 col-md-12 text-center"
        v-if="knowlarity_data_by_phone.length == 0 && !makingAJAX"
      >
        <p>We didn't get any data.</p>
      </div>


    </div>

    
      

  </div>
</template>

<script>
const moment = require("moment");

export default {
  data() {
    return {
      cx_id: 0,
      phone_number: "",
      support: "",
    };
  },
  created() {
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.loadData();
    window.addEventListener("play", function(evt)
    {
        if(window.$_currentlyPlaying)
        {
            window.$_currentlyPlaying.pause();
        } 
        window.$_currentlyPlaying = evt.target;
    }, true);
  },
  methods: {
      loadData(){
        this.$store.dispatch("get_knowlarity_data_by_phone", { endDate: this.date, customerNumber: '%2B' +91+this.phone_number });
        this.$store.dispatch("get_Knowlarity_agents");  
      },
      searchAgent(number){
        var x = this.agents.filter(data=>{
            return '+91'+data.phone == number
        })
        if(x.length>0){
            return x[0].first_name
        }else{
            return number
        }
    }
  },
  computed: {
    knowlarity_data_by_phone() {
      return this.$store.state.knowlarity_data_by_phone;
    },
    agents() {
      return this.$store.state.knowlarity_agents;
    },
    makingAJAX(){
      return this.$store.state.makingAJAX
    },
    date() {
      if (this.selectedDate) {
        return moment(this.selectedDate).format("YYYY-MM-DD");
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
  },
};
</script>

<style scoped>
audio {
    height: 25px;
}
.header {
  font-size: 15px;
  color: blue;
}
.labels {
  color: gray;
  font-size: 12px;
}
</style>
